module.exports = __webpack_public_path__ + "static/media/paper_types_modal.b5a6b497.jpg";